import {Pipe, PipeTransform} from '@angular/core';
import Order from '../../_entities/orders/order.entity';

@Pipe({
    name: 'totalQtyOrdered',
    pure: true
})
export class TotalQuantityOrderedPipe implements PipeTransform {
    transform(order: Order): number {
        const items = (order?.items ?? []) as any[];
        return items.reduce((result, item) => result + (item?.quantityOrdered ?? 0), 0);
    }
}
